import type { TOC } from '@ember/component/template-only';
import { fn } from '@ember/helper';

import definite from 'webapp/helpers/definite';
import CommonRenderingPreviewHeaderComponent from 'webapp/components/common/rendering/preview-header';
import ReportsPresentHelperComponent from 'webapp/components/reports/present-helper';
import ReportsViewerComponent from 'webapp/components/reports/viewer';
import ReportsViewerNavigationTogglerComponent from 'webapp/components/reports/viewer/navigation-toggler';
import type ReportsViewReportController from 'webapp/controllers/reports/view/report';

interface Args {
	controller: ReportsViewReportController;
}

const ReportsViewReportRouteTemplate: TOC<Args> = <template>
	<CommonRenderingPreviewHeaderComponent
		@model={{@controller.model}}
		@isEditBtnShown={{@controller.model.canCurrentUserEdit}}
		@onEdit={{@controller.editReport}}
		@present={{fn @controller.initializePresentMode "slides"}}
		@buttonSize="small"
	/>

	{{#if @controller.reportUIHelper}}
		<ReportsViewerNavigationTogglerComponent
			@reportUIHelper={{@controller.reportUIHelper}}
			@color={{definite @controller.currentVisibleSlide.shownColor}}
		/>
	{{/if}}

	<ReportsViewerComponent
		@model={{@controller.model}}
		@selectedSlide={{@controller.currentVisibleSlide}}
		@onSlideChange={{@controller.onSlideChange}}
	/>

	{{#if @controller.showPresentHelper}}
		<ReportsPresentHelperComponent @model={{@controller.reportPresentManagerInstance}} />
	{{/if}}
</template>;

export default ReportsViewReportRouteTemplate;
